"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var AirLineSeatIndividualSuite = function AirLineSeatIndividualSuite(props) {
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, sizeStyles, rest), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_6128_2850",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_6128_2850)"
  }, /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M4.63199 3.947C4.1327 3.61323 4.01811 2.93774 4.36188 2.45297C4.71384 1.96821 5.40137 1.85695 5.90066 2.19072C6.39994 2.5245 6.51453 3.19999 6.17076 3.68475C5.81881 4.16952 5.13127 4.28078 4.63199 3.947Z"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M5.67966 11.9734H13.2426V11.9893L13.3817 11.8622C15.1251 10.2887 14.9205 8.25426 13.8073 7.06221C12.5387 5.70328 9.95222 5.29004 7.26755 7.57877C6.69652 8.06389 6.47131 8.05656 6.44299 8.05564L6.44087 8.05558C6.40813 8.04764 6.35083 7.99201 6.28535 7.8728C6.23624 7.77744 6.15439 7.57082 6.05617 7.30857C5.47504 5.79865 4.77113 4.16157 3.76438 3.73243C3.43698 3.58939 3.09321 3.58144 2.774 3.70859C1.92276 4.03442 1.47258 4.38409 1.35799 4.81322C1.28433 5.07547 1.37436 5.30593 1.44803 5.39335C1.48077 5.43309 4.32914 9.78008 5.54052 11.743L5.67966 11.9734ZM12.8497 11.0198H6.23624V11.0278C5.09035 9.19995 2.8804 5.80659 2.35656 5.0119C2.43841 4.93243 2.64304 4.78143 3.13414 4.59071C3.2078 4.55892 3.28147 4.55892 3.36331 4.59865C4.06378 4.89571 4.788 6.75374 5.1153 7.59343L5.13127 7.6344C5.25405 7.95227 5.35227 8.19068 5.41774 8.30989C5.63055 8.69134 5.90884 8.91386 6.2608 8.97743C6.72734 9.0569 7.25118 8.84233 7.91416 8.2781C10.1159 6.40262 12.0967 6.63308 13.0789 7.69002C13.8155 8.47677 14.0365 9.84365 12.8497 11.0198ZM2.29108 4.90064C2.26653 4.86885 2.25016 4.83706 2.25016 4.83706C2.25504 4.84418 2.25993 4.85059 2.2646 4.85671C2.27557 4.8711 2.28534 4.88391 2.29108 4.90064Z"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M10.4903 12.5615C10.7537 12.5615 10.9672 12.775 10.9672 13.0383C10.9672 13.3017 10.7537 13.5151 10.4903 13.5151H7.96536C7.70202 13.5151 7.48855 13.3017 7.48855 13.0383C7.48855 12.775 7.70202 12.5615 7.96536 12.5615H10.4903Z"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M9.49387 5.71123C6.94834 2.30198 5.48322 4.79733 5.48322 4.79733C6.44905 6.39467 6.63731 7.33241 6.63731 7.33241C8.01238 5.95758 9.49387 5.71123 9.49387 5.71123Z"
  }, colorStyles))));
};
AirLineSeatIndividualSuite.propTypes = _inline_svg2.default.propTypes;
AirLineSeatIndividualSuite.defaultProps = _inline_svg2.default.defaultProps;
var _default = AirLineSeatIndividualSuite;
exports.default = _default;